import { OsmAPIList } from '@/api'

const api = new OsmAPIList();

export default {

  getGITypeInfoSelections({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getGITypeInfoSelections( (json) => {
        resolve(json);
      }, (err) => {
        reject(err)
      })
    })
  },


  // params: ID, policyLapseDate
  lapseGI({ state }, params) {
    return new Promise((resolve, reject) => {
      api.lapseGI(params, (json) => {
        switch (json.status) {
          case 200:
            resolve();
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err)
      })
    })
  },

  // params: ID, policyEndDate, files, attachment
  surrenderGI({ state }, params) {
    return new Promise((resolve, reject) => {
      api.surrenderGI(params, (json) => {
        switch (json.status) {
          case 200:
            resolve();
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err)
      })
    })
  },

  // params: ID, policyReinstateDate
  reinstateGI({ state }, params) {
    return new Promise((resolve, reject) => {
      api.reinstateGI(params, (json) => {
        switch (json.status) {
          case 200:
            resolve();
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err)
      })
    })
  },



  getGIDetail({ state, commit, dispatch }, isConcat = false, isClone = false) {
    return new Promise((resolve, reject) => {
      api.getGIDetail(state.newGI.policyID, isConcat, (json) => {
        switch (json.status) {
          case 200:
            if (!isClone) {
              commit({ type: 'setGIPolicyID', policyID: json.data.giGeneralInfo.ID });
              commit({ type: 'setPaymentMethodID', paymentMethodID: json.data.giPaymentMethod.ID });
              commit({ type: 'setGITypeID', giTypeID: json.data.giTypeInfo.ID });
            }
            dispatch('setAllGiInfo', json.data);
            resolve(json.data);
            break;
          default:
            reject(json);
            break;
        }

      }, (error) => {
        console.log(error);
        reject(error);
      })
    })
  },

  // getGIRenewal({ state, commit, dispatch }, isConcat = false) {
  //    return new Promise((resolve, reject) => {
  //      api.getGIDetail(state.newGI.policyID, isConcat, (json) => {
  //        switch (json.status) {
  //          case 200:
  //            commit({ type: 'setGIPolicyID', policyID: -1 });
  //            commit({ type: 'setPaymentMethodID', paymentMethodID: -1 });
  //            commit({ type: 'setGITypeID', giTypeID: -1});
  //            resolve(json.data);
  //            break;
  //          default:
  //            reject(json);
  //            break;
  //        }

  //      }, (error) => {
  //        console.log(error);
  //        reject(error);
  //      })
  //    })
  //  },

  searchGIList({ state }, searchValue) {
    return new Promise((resolve, reject) => {
      api.searchGIList(searchValue, (json) => {
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },

  // params : count, page, workflowStep, status, type
  getGIList({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getGIList(params, (json) => {
        resolve(json.data);
      }, (error) => {
        reject(error);
      })
    })
  },

  setWorkflowCurrentStep({ commit, state }, currentStep) {
    console.log(currentStep);
    commit({ type: 'setWorkflowCurrentStep', currentStep: currentStep })
    var currentStepRequirements = state.newGI.workflowStepRequirement['step' + (currentStep + 1)];
    currentStepRequirements.forEach((item) => {
      commit({
        type: 'setCurrentStepFieldStatus',
        name: item.name,
        disabled: item.status.disabled,
        hide: item.status.hide
      });
    })
  },

  // get GI product type list from api
  getGITypeList({ commit }) {
    api.getGIProductTypeList(
      (json) => {
        commit({ type: 'setPolicyTypeList', list: json.data });
      },
      (error) => {
        console.error(error);
      });
  },

  getGIProductFields({ commit }, policyType) {
    api.getGIProductFields(policyType,
      (json) => {
        commit({ type: 'setGIProductFields', fieldList: json.data.list });
      },
      (error) => {
        console.error(error);
      })
  },


  createGIPolicy({ state, commit, dispatch }, policyDetails) {
    return new Promise((resolve, reject) => {
      api.createGIPolicy(policyDetails, (json) => {
          switch (json.status) {
            case 200:
              dispatch('setWorkflowCurrentStep', 1);
              commit({ type: 'setGIPolicyID', policyID: json.data.giGeneralInfo.ID });
              commit({ type: 'setPaymentMethodID', paymentMethodID: json.data.paymentMethod.ID });
              commit({ type: 'setGITypeID', giTypeID: json.data.giTypeInfo });
              commit({ type: 'setPolicyAgent', policyAgent: json.data.giGeneralInfo.policyAgent });
              commit({ type: 'updatePaymentMethodLinkedEntityID', linkedEntityID: json.data.paymentMethod.linkedEntityID });
              console.log(state.newGI.giGeneralInfo.policyAgent);
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }

        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  confirmGIPolicy({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      api.confirmGIPolicy(payload.form, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.giGeneralInfo.policyAgent });
              if (payload.isToPrev) {
                dispatch('setWorkflowCurrentStep', 1);
                resolve(json);
                break;
              }
              dispatch('setWorkflowCurrentStep', 2);
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
          resolve();
        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  sendOutGIPolicy({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      api.sendOutGIPolicy(payload.form, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.giGeneralInfo.policyAgent });
              if (payload.isToPrev) {
                dispatch('setWorkflowCurrentStep', 2)
                resolve(json);
                break;
              }
              dispatch('setWorkflowCurrentStep', 3)
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }

        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  saveGIPolicy({ commit, dispatch }, policyDetails) {
    return new Promise((resolve, reject) => {
      api.saveGIPolicy(policyDetails, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.giGeneralInfo.policyAgent });
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  rejectGIPolicy({ commit, dispatch }, policyID) {
    return new Promise((resolve, reject) => {
      api.rejectGIPolicy(policyID, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.giGeneralInfo.policyAgent });
              dispatch('setWorkflowCurrentStep', 5)
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  inforceGIPolicy({ commit, dispatch }, policyDetails) {
    return new Promise((resolve, reject) => {
      api.inforceGIPolicy(policyDetails, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.giGeneralInfo.policyAgent });
              dispatch('setWorkflowCurrentStep', 6)
              commit({ type: 'setGIApproveAgent', approveAgent: json.data.giGeneralInfo.serviceAgentAgentID });
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  deleteGIPolicy({ commit, dispatch }, policyID) {
    return new Promise((resolve, reject) => {
      api.deleteGIPolicy(policyID, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.giGeneralInfo.policyAgent });
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  companyReceiveGIPolicy({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      api.companyReceiveGIPolicy(payload.form, (json) => {
          switch (json.status) {

            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.giGeneralInfo.policyAgent });
              if (payload.isToPrev) {
                dispatch('setWorkflowCurrentStep', 6)
                resolve(json);
                break;
              }
              dispatch('setWorkflowCurrentStep', 7)
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }

        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  agentReceiveGIPolicy({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      api.agentReceiveGIPolicy(payload.form, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.giGeneralInfo.policyAgent });
              if (payload.isToPrev) {
                dispatch('setWorkflowCurrentStep', 7)
                resolve(json);
                break;
              }
              dispatch('setWorkflowCurrentStep', 8)
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }

        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  customerReceiveGIPolicy({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      api.customerReceiveGIPolicy(payload.form, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.giGeneralInfo.policyAgent });
              // if (payload.isToPrev) {
              //   dispatch('setWorkflowCurrentStep', 8)
              //   resolve(json);
              //   break;
              // }
              resolve(json);
              // dispatch('setWorkflowCurrentStep', 9)
              break;
            default:
              reject(json);
              break;
          }

        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  setAllGiInfo({ commit }, giObj) {
    commit({ type: 'setGITypeInfo', giTypeInfo: giObj.giTypeInfo });
    commit({ type: 'setGIGeneralInfo', giGeneralInfo: giObj.giGeneralInfo, giPaymentMethod: giObj.giPaymentMethod });
    commit({ type: 'setGIAttachments', giAttachments: giObj.attachment });
    commit({ type: 'setGITypeID', giTypeID: giObj.giTypeInfo.ID });
    commit({ type: 'setGIPolicyID', policyID: giObj.giGeneralInfo.ID });
    commit({ type: 'setPaymentMethodID', paymentMethodID: giObj.giPaymentMethod.ID });
  },

  resetNewGIState({ commit, dispatch }) {
    dispatch('setGIGeneralInfoInitState');
    commit({ type: 'setGITypeInfo', giTypeInfo: {} });
    commit({ type: 'setIsRejected', value: false });
    commit({ type: 'setIsCompleted', value: false });
    dispatch('setWorkflowCurrentStep', 0);
  },

  editPolicyAgent({ commit, dispatch }, form) {
    return new Promise((resolve, reject) => {
      api.editPolicyAgent(form, (json) => {
          switch (json.status) {
            case 200:
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  deletePolicyAgent({ commit, dispatch }, ID) {
    var params = { ID: ID }
    return new Promise((resolve, reject) => {
      api.deletePolicyAgent(params, (json) => {
          switch (json.status) {
            case 200:
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  setGIGeneralInfoInitState({ commit }) {
    var giGeneralInfo = {
      productID: -1,
      policyNumber: '',
      policyReference: '',
      applicationDate: '',
      applicationReceiveDate: '',
      policyCurrency: 'HKD',
      policyType: '',
      customerActuallyPaid: 0,
      modalPremium: 0,
      approveAgent: -1,
      // originalAgent: -1,
      // currentAgent: -1,
      policyAgent: [{
        agentID: -1,
        agentSplitRate: '',
        isActive: "Y",
        isServiceAgent: "Y",
        effectiveDate: '',
        expiryDate: ''
      }],
      ownerCustomer: -1,
      insuredCustomer: -1,
      policyFee: 0,
      agentCommissionRate: 0,
      newBusinessOrRenewal: 'N',
      levyOrMib: 0,
      specialLevy: 0,
      remarks: '',
      premiumPaid: 0,
      agentCommissionPaid: 0,
      insurerRebate: 0,
      // chequeToFortune: 0,
      // chequeToFortuneNumber: '',
      chequeToInsurer: 0,
      chequeToInsurerNumber: '',
      chequeIssueDate: '',
      sentOutDate: '',
      sentOutMedium: '',
      sentOutReference: '',
      // courierNumber: '',
      effectiveDate: '',
      expiryDate: '',
      issueDate: '',
      companyReceiveDate: '',
      agentReceiveDate: '',
      customerReceiveDate: '',
      policyAgentChangeReason: '',
      // version: 1,
      docs: {}
    }
    var giPaymentMethod = {
      paymentMethod: "I",
      companyBank: "",
      paymentReference: "",
      paymentDate: "",
      paymentAmount: 0,
      // version: 1
    }
    commit({ type: 'setGIGeneralInfo', giGeneralInfo: giGeneralInfo, giPaymentMethod: giPaymentMethod })
  }
}



// WEBPACK FOOTER //
// ./src/Osm/GIPolicy/store/actions.js